/**
 * Strona mobilna do zrobienia zdjęcia paragonu i przesłania do trwającej sesji
 * na komputerze. Ładuje się po zeskanowaniu QR z modala protokołu.
 *
 * Route: /protocol-photo/:handoffId
 */
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const ProtocolPhotoUpload = () => {
  const { handoffId } = useParams();
  const [session, setSession] = useState(null);
  const [error, setError] = useState('');
  const [uploading, setUploading] = useState(false);
  const [done, setDone] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    axios.get(`${API}/api/cancellation-protocols/photo-handoffs/${handoffId}`)
      .then((r) => setSession(r.data))
      .catch((e) => setError(e?.response?.data?.detail || 'Sesja nie znaleziona'));
  }, [handoffId]);

  const handleFile = async (file) => {
    if (!file) return;
    setUploading(true);
    setError('');
    try {
      const fd = new FormData();
      fd.append('file', file);
      const r = await axios.post(
        `${API}/api/cancellation-protocols/photo-handoffs/${handoffId}/upload`,
        fd,
        { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 3 * 60 * 1000 },
      );
      if (r.data?.ok) setDone(true);
    } catch (e) {
      setError(e?.response?.data?.detail || 'Błąd wysyłki');
    } finally { setUploading(false); }
  };

  const wrap = {
    minHeight: '100vh', background: '#0b0e14', color: '#fff',
    display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
    padding: 24, fontFamily: 'system-ui, sans-serif', textAlign: 'center',
  };

  if (error) {
    return (
      <div style={wrap}>
        <div style={{ fontSize: 42 }}>⚠️</div>
        <h1 style={{ fontSize: 20 }}>Sesja niedostępna</h1>
        <p style={{ color: '#94a3b8', fontSize: 14 }}>{error}</p>
      </div>
    );
  }

  if (!session) {
    return <div style={wrap}><div style={{ fontSize: 40 }}>⏳</div><p>Ładowanie…</p></div>;
  }

  if (done) {
    return (
      <div style={wrap}>
        <div style={{ fontSize: 60 }}>✅</div>
        <h1 style={{ fontSize: 22, margin: '20px 0 10px' }}>Zdjęcie wysłane!</h1>
        <p style={{ color: '#94a3b8', fontSize: 14, maxWidth: 320 }}>
          Możesz wrócić do komputera — zdjęcie automatycznie pojawi się w formularzu.
        </p>
        <button
          onClick={() => { setDone(false); setSession({ ...session, photoUrl: '' }); }}
          style={{
            marginTop: 30, padding: '10px 18px',
            background: 'transparent', color: '#d4af37',
            border: '1px solid #d4af37', borderRadius: 8,
            cursor: 'pointer', fontSize: 13,
          }}
        >📷 Zrób kolejne zdjęcie</button>
      </div>
    );
  }

  return (
    <div style={wrap}>
      <div style={{ fontSize: 50 }}>📷</div>
      <h1 style={{ fontSize: 22, margin: '18px 0 8px' }}>Zrób zdjęcie paragonu</h1>
      <p style={{ color: '#94a3b8', fontSize: 13, maxWidth: 320 }}>
        Zrobione zdjęcie automatycznie pojawi się w formularzu protokołu na komputerze.
      </p>

      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        capture="environment"
        style={{ display: 'none' }}
        onChange={(e) => {
          const f = e.target.files?.[0];
          if (f) handleFile(f);
          e.target.value = '';
        }}
      />
      <button
        onClick={() => inputRef.current?.click()}
        disabled={uploading}
        data-testid="mobile-camera-btn"
        style={{
          marginTop: 40, padding: '18px 32px',
          background: 'linear-gradient(135deg, #d4af37, #b8860b)',
          color: '#000', border: 'none', borderRadius: 12,
          fontSize: 18, fontWeight: 800,
          cursor: uploading ? 'wait' : 'pointer',
          boxShadow: '0 10px 30px rgba(212,175,55,0.35)',
          minWidth: 240,
        }}
      >
        {uploading ? '⏳ Wgrywam…' : '📸 Aparat'}
      </button>

      <p style={{ marginTop: 30, fontSize: 11, color: '#64748b' }}>
        Sesja: {handoffId}
      </p>
    </div>
  );
};

export default ProtocolPhotoUpload;
